/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device-md': {
    width: 16,
    height: 16,
    viewBox: '0 4 24 16',
    data: '<path pid="0" d="M4 6h16v10H4m16 2a2 2 0 002-2V6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4z"/>'
  }
})
